import { render, staticRenderFns } from "./postJobTask.vue?vue&type=template&id=2d4eb818&scoped=true"
import script from "./postJobTask.vue?vue&type=script&lang=js"
export * from "./postJobTask.vue?vue&type=script&lang=js"
import style0 from "./postJobTask.vue?vue&type=style&index=0&id=2d4eb818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4eb818",
  null
  
)

export default component.exports